import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
// import { responsiveImageFragment } from '../fragments/images'

export const contattiPage = gql`
  ${seoFragment}
  query ContattiPage($locale: SiteLocale) {
    contatti(locale: $locale) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
    }
  }
`
